import { Navigate, useParams } from "react-router-dom";

import { PatientEncounterPage } from "@src/deprecated/pages/PatientEncounter";
import { navigation } from "@src/shared/navigation";

export function meta() {
  return [
    { title: "Patient Encounter" },
    { name: "description", content: "Patient encounter page" },
  ];
}

export default function PatientEncounter() {
  const params = useParams();

  const patientId = params.patientId;
  const encounterId = params.encounterId;

  if (!patientId || !encounterId) {
    return <Navigate to={navigation.dashboardNotFound()} />;
  }

  return (
    <PatientEncounterPage patientId={patientId} encounterId={encounterId} />
  );
}
